<!-- =========================================================================================
    File Name: SalesEdit.vue
    Description: Edit sales component
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="saleEdit" class="">
    <vs-prompt
      :vs-title="'Kaydı Güncelle Satış #' + this.currentItem.saleOrderId + ' | ' + this.currentItem.saleOrderStatus + ' | ' + this.invoiceStatus"
      vs-accept-text="Kaydet"
      vs-cancel-text="Vazgeç"
      vs-button-cancel="border"
      @vs-cancel="cancel"
      @vs-accept="accept"
      @vs-close="close"
      :vs-is-valid="!isEditDisabled && validateForm"
      :vs-active.sync="activePrompt"
    >
      <div>
        <feather-icon v-if="1 == 2" icon="RefreshCwIcon" title="Yenile" svgClasses="h-5 mr-5 hover:text-danger cursor-pointer" @click="accept()" />
        <VuePerfectScrollbar class="scroll-area" :settings="settings">
          <div class="vx-row mt-2 mr-1">
            <div class="vx-col" v-if="currentItem.customer">
              <a
                id="lnkMusteri"
                size="small"
                target="_blank"
                :href="'/contactsView/' + currentItem.customerId"
                name="musteriAd"
                placeholder="Müşteri Adı Soyadı"
                class="w-full mb-0 mt-0"
                style="color: #67e; font-weight: bold; white-space: nowrap;"
                :title="currentItem.customer"
                >{{ currentItem.customer.substr(0, 20) }}</a
              >

              <a target="_blank" :href="'/AccountMovementByModuleId/' + currentItem.saleOrderId" class="w-full ml-5" style="color: orange; font-weight: bold; white-space: nowrap;" title="Borçlanma Muhasebe">Muhasebe Satış Id</a>
              <a target="_blank" :href="'/AccountMovementByCustomerId/' + currentItem.customerId" class="w-full ml-5" style="color: #7393b3; font-weight: bold; white-space: nowrap;" title="Borçlanma Muhasebe">Muhasebe Müşteri Id</a>
              <a target="_blank" :href="'/IncomeByOrderId/' + currentItem.customerId + '/' + currentItem.saleOrderId" class="w-full ml-5" style="color: darkgray; font-weight: bold; white-space: nowrap;" title="Gelir Gider Ödeme">Müşteri Ödeme</a>
              <a target="_blank" :href="'/IncomeReturnByOrderId/' + currentItem.customerId + '/' + currentItem.saleOrderId" class="w-full ml-5" style="color: red; font-weight: bold; white-space: nowrap;" title="Gelir Gider Ödeme">Müşteri İade</a>

              <div class="vx-col mt-5">
                <vs-button size="small" style="width: 120px;" type="filled" @click="createAccountMovement" v-if="currentItem.saleOrderStatusId > 3 && currentItem.saleOrderStatusId < 98" class="ml-2 mb-3">ERP Muhasebe</vs-button>
                <vs-button size="small" style="width: 120px;" type="filled" @click="popupActivationForm = true" v-if="currentItem.saleOrderStatusId > 3 && currentItem.saleOrderStatusId < 98" class="ml-2" color="success">Aktivasyon Talep</vs-button>
                <vs-button size="small" style="width: 120px;" type="filled" @click="openReturnRequest" v-if="currentItem.saleOrderStatusId > 3 && currentItem.saleOrderStatusId < 98" class="ml-2" color="danger">İade oluştur</vs-button>
                <vs-button size="small" style="width: 120px;" type="filled" @click="importToLogo" v-if="currentItem.saleOrderStatusId > 3 && currentItem.saleOrderStatusId < 98" class="ml-2 mb-3" color="danger">Logoya aktar</vs-button>
                <vs-button v-if="false && currentItem.saleOrderStatusId == 8" class="ml-2" size="small" color="danger" type="filled" @click="createInvoice(false)">Fatura Kes</vs-button>
                <vs-button v-if="false && currentItem.saleOrderStatusId == 8" class="ml-2" size="small" color="danger" type="filled" @click="createInvoice(true)">Fatura Kes (KDVli)</vs-button>
              </div>
            </div>

            <div class="vx-col md:w-1/6">
              <label class="w-full mb-0 mt-2 text-sm">
                <b>Müşteri Telefon</b>
              </label>
              <vs-input disabled size="small" placeholder="Müşteri Telefonu" name="musteriAd" class="w-full mb-0 mt-0" v-model="beautifyPhone" :color="validateForm ? 'success' : 'danger'" />
            </div>
          </div>

          <div class="vx-row mt-2 mr-1">
            <div class="vx-col w-1/2">
              <label class="w-full mb-0 mt-2 text-sm">
                <b>Fatura Adresi</b>
              </label>
              <vs-textarea disabled v-validate="'required'" placeholder="Fatura Adresi" name="musteriAd" class="w-full mb-0 mt-0" v-model="currentItem.invoiceAddress" :color="validateForm ? 'success' : 'danger'" />
            </div>

            <div class="vx-col w-1/2">
              <label class="w-full mb-0 mt-2 text-sm">
                <b>Teslimat Adresi</b>
              </label>
              <vs-textarea v-validate="'required'" placeholder="Teslimat Adresi" name="musteriAd" :disabled="isEditDisabled" class="w-full mb-0 mt-0" v-model="currentItem.deliveryAddress" :color="validateForm ? 'success' : 'danger'" />
            </div>
          </div>
          <div class="vx-row mt-2 mr-1">
            <div class="vx-col w-1/2">
              <label class="w-full mb-0 mt-2 text-sm">
                <b>Düzenleme Tarihi</b>
              </label>
              <input :disabled="isEditDisabled" class="w-full mb-2 mt-0" type="datetime-local" v-model="currentItem.manualCreatedDate" name="arrangementDate" @change="isValid($event, '', 'red')" />
            </div>
            <div class="vx-col w-1/2">
              <label class="w-full mb-0 mt-2 text-sm">
                <b>Teslimat Tarihi</b>
              </label>

              <input :disabled="isEditDisabled" class="w-full mb-2 mt-0" type="datetime-local" v-model="currentItem.validUntil" name="arrangementDate" @change="isValid($event, '', 'red')" />
            </div>
          </div>

          <div class="vx-row mr-1">
            <div class="vx-col w-1/2">
              <v-select
                :disabled="isEditDisabled"
                v-model="tempPaymentType"
                class="w-full select-large mb-2 style-chooser"
                placeholder="Ödeme şekli seçin"
                v-validate="'required'"
                name="selectedPaymentType"
                :options="selectedPaymentTypeOptions"
                :reduce="(selectedPaymentTypeOptions) => selectedPaymentTypeOptions.id"
                label="value"
              >
                <span slot="no-options">Eşleşen Veri Yok</span>
              </v-select>
            </div>
            <div class="vx-col w-1/2">
              <v-select
                :disabled="isEditDisabled"
                v-model="tempOrderType"
                class="w-full select-large mb-2 style-chooser"
                placeholder="Satış Türü seçin"
                name="salectedSaleORderType"
                :options="selectedOrderTypesOptions"
                :reduce="(selectedOrderTypesOptions) => selectedOrderTypesOptions.id"
                label="value"
              >
                <span slot="no-options">Eşleşen Veri Yok</span>
              </v-select>
            </div>
          </div>
          <!-- 5.row -->

          <div class="vx-row mr-1">
            <div class="vx-col w-1/2">
              <v-select :disabled="isEditDisabled" class="w-full select-large mb-2 style-chooser" placeholder="Teslimat Şekli Seçin" name="selectedDeliveryType" v-model="tempDeliveryType" :options="selectedDeliveryTypeOptions" label="value">
                <span slot="no-options">Eşleşen Veri Yok</span>
              </v-select>
            </div>

            <div class="vx-col md:w-1/2">
              <div class="vx-row">
                <div class="vx-col md:w-1/4 flex items-center">
                  <span style>
                    {{ currentItem.taxIncluded ? "KDV Dahil" : "KDV Hariç" }}
                  </span>
                  <vs-switch v-model="currentItem.taxIncluded" @change="calculate" :disabled="isEditDisabled" />
                </div>
                <div class="vx-col md:w-1/4 flex items-center">
                  <span style>
                    Tam Fatura
                  </span>

                  <vs-switch v-model="currentItem.isFullInvoice" :disabled="isEditDisabled" />
                </div>
                <div v-if="currentItem.technicId > 0" class="vx-col md:w-3/4 flex items-center">
                  <div v-if="currentItem.taxIncluded" class="flex items-center">
                    <!--15111-->
                    <vs-radio class="flex items-center mr-2" v-model="convertTaxValue" vs-name="convertTax" vs-value="1">{{ parseFloat(grandTotal.priceDiscounted).toFixed(2) }}{{ " " + ((tempCurrency && tempCurrency.logo) || "₺") }}</vs-radio>
                    <vs-radio v-if="currentItem.createdDate<='2023-07-15'" class="flex items-center mr-2" v-model="convertTaxValue" vs-name="convertTax" vs-value="2"
                      >{{ (parseFloat(grandTotal.priceDiscounted) / 1.18).toFixed(2) }}{{ " " + ((tempCurrency && tempCurrency.logo) || "₺") }}</vs-radio
                    >
                    <vs-radio v-if="currentItem.createdDate>'2023-07-15'" class="flex items-center mr-2" v-model="convertTaxValue" vs-name="convertTax" vs-value="2"
                      >{{ (parseFloat(grandTotal.priceDiscounted) / 1.20).toFixed(2) }}{{ " " + ((tempCurrency && tempCurrency.logo) || "₺") }}</vs-radio
                    >
                    <vs-button class="flex items-center" size="small" type="filled" @click="changeTax">Kdv Hariç Yap</vs-button>
                  </div>
                  <div v-else class="flex items-center">
                    <vs-radio v-if="currentItem.createdDate<='2023-07-15'" class="flex items-center mr-2" v-model="convertTaxValue" vs-name="convertTax" vs-value="3"
                      >{{ (parseFloat(grandTotal.priceDiscounted) * 1.18).toFixed(2) }}{{ " " + ((tempCurrency && tempCurrency.logo) || "₺") }}</vs-radio
                    >
                    <vs-radio v-if="currentItem.createdDate>'2023-07-15'" class="flex items-center mr-2" v-model="convertTaxValue" vs-name="convertTax" vs-value="3"
                      >{{ (parseFloat(grandTotal.priceDiscounted) * 1.18).toFixed(2) }}{{ " " + ((tempCurrency && tempCurrency.logo) || "₺") }}</vs-radio
                    >
                    <vs-radio class="flex items-center mr-2" v-model="convertTaxValue" vs-name="convertTax" vs-value="4">{{ parseFloat(grandTotal.priceDiscounted).toFixed(2) }}{{ " " + ((tempCurrency && tempCurrency.logo) || "₺") }}</vs-radio>
                    <vs-button class="flex items-center mr-2" size="small" type="filled" @click="changeTax">Kdv Dahil Yap</vs-button>
                  </div>
                </div>
                <div class="vx-col md:w-1/4">
                  <v-select v-if="!isEditDisabled" class="w-full select-large mb-2 style-chooser" placeholder="Para birimi seçin" name="selectedMoneyCurrency" v-model="tempCurrency" :options="selectedMoneyCurrencyOptions" label="value">
                    <span slot="no-options">Eşleşen Veri Yok</span>
                  </v-select>
                </div>
                <div class="vx-col md:w-1/2 flex items-center" v-if="false">
                  <span :style="currentItem.amount > 0 ? 'color:red' : 'color:black'">Müşteri Bakiye: {{ currentItem.amount }} TL</span>
                </div>
              </div>
            </div>
          </div>

          <div class="vx-row mt-2 mr-1">
            <div class="vx-col md:w-full">
              <h6 class="w-full mb-0 mt-2">Notlar</h6>
              <vs-textarea name="orderNote" class="w-full mb-0 mt-0" v-model="currentItem.saleOrderNote" :disabled="isEditDisabled" :color="validateForm ? 'success' : 'danger'" />
            </div>
          </div>

          <div class="vx-row mt-2 mr-1">
            <div class="vx-col md:w-full" v-if="!openReturnRequestPopup">
              <vs-table noDataText="Tabloda Veri Yok" :data="selectedProducts">
                <template slot="header">
                  <h5>Ürünler</h5>
                  <vs-button v-if="!isEditDisabled" size="small" type="filled" @click="openAgEditProducts">Ürün Değiştir</vs-button>
                </template>

                <template slot="thead">
                  <vs-th style="width: 400px;">Ürün</vs-th>
                  <vs-th>Birim Fiyat</vs-th>
                  <vs-th>Adet</vs-th>
                  <vs-th>Depo</vs-th>
                  <vs-th>Satış Fiyatı</vs-th>
                  <vs-th>İndirim Yüzdesi</vs-th>
                  <vs-th v-if="currentItem.taxIncluded">KDV</vs-th>
                  <vs-th>Toplam</vs-th>
                  <vs-th>İşlem</vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr class="trWithPadding" :state="tr.isReturned ? 'danger' : tr.isSent ? 'success' : ''" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td hidden :data="tr.productId">{{ tr.productId }}</vs-td>
                    <!-- ürün adı -->
                    <vs-td :data="tr.productName">{{ tr.productName + " ( PId= " + tr.productId + " )" }}</vs-td>
                    <!-- fıyat -->
                    <vs-td :data="tr.price"> {{ parseFloat(tr.price).toFixed(2) }}{{ " " + ((tempCurrency && tempCurrency.logo) || "₺") }} </vs-td>
                    <!-- adet -->
                    <vs-td :data="tr.quantity">
                      {{ tr.quantity + " Adet" }}
                    </vs-td>
                    <!-- depo-->
                    <vs-td>
                      {{ tr.wareHouseId != -1 ? tr.wareHouse : "Depo Seçilmemiş" }}
                    </vs-td>
                    <!-- vergili satıs fıyatı -->
                    <vs-td v-if="!currentItem.taxIncluded"> {{ parseFloat(tr.sellPrice).toFixed(2) }}{{ " " + ((tempCurrency && tempCurrency.logo) || "₺") }} </vs-td>
                    <!-- vergisiz satıs fıyatı -->
                    <vs-td v-if="currentItem.taxIncluded && currentItem.createdDate<='2023-07-15'"> {{ parseFloat(tr.sellPrice * 0.84745).toFixed(2) }}{{ " " + ((tempCurrency && tempCurrency.logo) || "₺") }} </vs-td>
                    <vs-td v-if="currentItem.taxIncluded && currentItem.createdDate>'2023-07-15'"> {{ parseFloat(tr.sellPrice * 0.83333).toFixed(2) }}{{ " " + ((tempCurrency && tempCurrency.logo) || "₺") }} </vs-td>
                    
                    <!-- ındırım -->
                    <vs-td :style="profit(tr) < 0 ? 'color:red;font-weight:bolder;' : ''">{{ beautifyProfit(tr) }}</vs-td>
                    <!-- vergi -->
                    <vs-td v-if="currentItem.taxIncluded">%20</vs-td>
                    <!-- toplam vergili fiyat -->
                    <vs-td :data="data[indextr].quantity"> {{ (data[indextr].quantity * data[indextr].sellPrice).toFixed(2) }}{{ " " + ((tempCurrency && tempCurrency.logo) || "₺") }} </vs-td>

                    <!-- işlem -->
                    <vs-td>
                      <vs-button type="border" size="small" icon-pack="feather" icon="icon-trash" v-if="!isEditDisabled" color="danger" @click="deleteRow(tr)"></vs-button>
                      <span color="danger" v-if="tr.isReturned">
                        {{ beautifyReturned(tr) }}
                      </span>
                      <span v-if="tr.isSent && !tr.isReturned">Gönderildi</span>
                    </vs-td>
                  </vs-tr>

                  <vs-tr v-if="data.length != 0">
                    <vs-td>
                      <hr />
                    </vs-td>
                    <vs-td>
                      <hr />
                    </vs-td>
                    <vs-td>
                      <hr />
                    </vs-td>
                    <vs-td>
                      <hr />
                    </vs-td>
                    <vs-td>
                      <hr />
                    </vs-td>
                    <vs-td>
                      <hr />
                    </vs-td>
                    <vs-td>
                      <hr />
                    </vs-td>
                    <vs-td>
                      <hr />
                    </vs-td>
                  </vs-tr>

                  <vs-tr v-if="data.length != 0">
                    <vs-th>Genel Toplam</vs-th>
                    <vs-th colspan="4"></vs-th>
                    <vs-th>{{ beautifyDiscount }}</vs-th>
                    <vs-th v-if="currentItem.taxIncluded"></vs-th>
                    <vs-th> {{ parseFloat(grandTotal.priceDiscounted).toFixed(2) }}{{ " " + ((tempCurrency && tempCurrency.logo) || "₺") }} </vs-th>
                    <vs-th colspan="1"></vs-th>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </div>
          <returnRequestPopup v-model="currentItem" v-if="openReturnRequestPopup" @updateCompleted="closeReturnRequestPopup"></returnRequestPopup>
          <ag-grid-table :openProducts="openProductPopup" v-if="openProductPopup" v-model="agSelectedProducts" @hideProducts="closeProductPopup"></ag-grid-table>
        </VuePerfectScrollbar>
      </div>
    </vs-prompt>

    <vs-prompt
      style="z-index: 100001;"
      :vs-title="'Aktivasyon Formu #' + currentItem.saleOrderId + ' | Bakiye / Limit : ' + currentItem.balance + ' / ' + currentItem.limit"
      vs-accept-text="Talep Formu Oluştur"
      vs-cancel-text="İptal"
      vs-button-cancel="border"
      :vs-active.sync="popupActivationForm"
      @vs-accept="SaveActivationForm()"
      :vs-buttons-hidden="(currentItem.accountMovementStatus == 'M' && currentItem.balance + currentItem.limit >= 0) == true ? false : true"
      @vs-cancel="popupActivationForm = false"
    >
      <div class="vx-row">
        <div class="vx-col md:w-1/2 w-full">
          <div class="mt-2">
            <label><b>Product</b></label>
            <v-select
              name="amountTypeSelection"
              placeholder="Product"
              :options="currentItem.products"
              label="productName"
              class="w-full"
              @input="
                (e) => {
                  this.currentItem.productName = e.productName;
                  this.currentItem.productId = e.productId;
                  this.currentItem.serialCode1 = e.SerialCode;
                  this.currentItem.saleOrderLineId = e.orderLineId;
                  this.currentItem.licencePeriod = e.LicencePeriod;
                }
              "
            >
              <span slot="no-options">Eşleşen Veri Yok</span>
            </v-select>
          </div>
        </div>
        <div class="vx-col md:w-1/2 w-full">
          <div class="mt-2">
            <label><b>Address</b></label>
            <vs-input type="text" class="w-full" v-model="currentItem.deliveryAddress" />
          </div>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col md:w-1/2 w-full">
          <div class="mt-2">
            <label><b>Phone</b></label>
            <vs-input type="text" class="w-full" v-model="currentItem.customerPhone" />
          </div>
        </div>
        <div class="vx-col md:w-1/2 w-full">
          <div class="mt-2">
            <label><b>Tax Number</b></label>
            <vs-input type="text" class="w-full" v-model="currentItem.taxNumber" />
          </div>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col md:w-1/2 w-full">
          <div class="mt-2">
            <label><b>S/N 1</b></label>
            <vs-input type="text" class="w-full" v-model="currentItem.serialCode1" />
          </div>
        </div>
        <div class="vx-col md:w-1/2 w-full">
          <div class="mt-2">
            <label><b>S/N 2</b></label>
            <vs-input type="text" class="w-full" v-model="currentItem.serialCode2" />
          </div>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col md:w-1/2 w-full">
          <div class="mt-2">
            <label><b>Mail</b></label>
            <vs-input type="text" class="w-full" v-model="currentItem.email" />
          </div>
        </div>
        <div class="vx-col md:w-1/2 w-full">
          <div class="mt-2">
            <label><b>Master Mail</b></label>
            <vs-input type="text" class="w-full" v-model="currentItem.masterEMail" />
          </div>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col md:w-1/2 w-full">
          <div class="mt-2">
            <label><b>Description</b></label>
            <vs-textarea type="text" class="w-full" v-model="currentItem.description" />
          </div>
        </div>
        <div class="vx-col md:w-1/2 w-full">
          <div class="vx-row w-full mt-5">
            <div class="vx-col md:w-1/4">
              <label
                ><b> Bakiye : {{ currentItem.balance }}</b></label
              >
            </div>
            <div class="vx-col md:w-1/4">
              <label
                ><b> Limit : {{ currentItem.limit }}</b></label
              >
            </div>
          </div>

          <div class="vx-row w-full mt-2">
            <div class="vx-col md:w-1/4">
              <vs-checkbox style="" disabled="true" :checked="currentItem.accountMovementStatus == 'M'">Satıcı Onay</vs-checkbox>
            </div>
            <div class="vx-col md:w-1/4">
              <vs-checkbox style="" disabled="true" :checked="currentItem.balance + currentItem.limit >= 0">Cari Onay</vs-checkbox>
            </div>
          </div>
        </div>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import { repository } from "@/_services/repository.js";
import vSelect from "vue-select";
import agGridTable from "./addComponents/agGridTable.vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { globalFunctions } from "@/_services/globalFunctions.js";
import returnRequestPopup from "./ReturnRequestPopup";

export default {
  components: {
    agGridTable,
    vSelect,
    VuePerfectScrollbar,
    globalFunctions,
    returnRequestPopup,
  },
  props: {
    displayPrompt: {
      type: Boolean,
      required: true,
    },
    technicItemId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      popupActivationForm: false,
      softwareProductList: {},
      invoiceStatus: "",
      convertTaxValue: "",
      agSelectedProducts: [],
      openProductPopup: false,
      kdvRate: 0.20,
      tempCurrency: { id: 0, logo: "", name: "", value: "" },
      tempPaymentType: { id: 0, value: "" },
      selectedProducts: [],
      tempDeliveryType: { id: 0, value: "" },
      openReturnRequestPopup: false,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.3,
        suppressScrollX: true,
      },
      tempOrderType: {
        classList: "",
        id: 0,
        other: "",
        style: "",
        userSelectable: "",
        value: "",
      },
      selectedOrderTypesOptions: [],
      selectedMoneyCurrencyOptions: [],
      selectedPaymentTypeOptions: [],
      selectedDeliveryTypeOptions: [],
      beautifyPhone: "",
      serviceStatus: [
        { text: "KDV'li", value: true },
        { text: "KDV'siz", value: false },
      ],
      searchQuery: "",
      currentItem: {},
      previousNotes: "",

      customerSearch: [],
      completed: false,
      salesModel: {
        id: this.technicItemId,
      },
      grandTotal: {
        sumUnitPrice: 0,
        sumSalePrice: 0,
        sumquantity: 0,
        price: 0,
        discountPercent: 0,
      },
      isEditDisabled: true,
    };
  },
  mounted() {
    document.addEventListener("keydown", (e) => {
      if (e.keyCode == 27) {
        if (this.popupActivationForm) this.popupActivationForm = false;
        else this.$emit("hideDisplayPrompt", false);
      }
    });
  },

  methods: {
    beautifyReturned(tr) {
      if (tr.returnedCount > 0) {
        if (tr.returnedCount == tr.quantity) {
          return "Tamamı iade edildi";
        }
        return tr.returnedCount + " adet iade edildi";
      }
      return "iade edildi";
    },
    isValid(event, success, fail) {
      if (event instanceof Event) {
        if (event["target"] && event.target instanceof HTMLInputElement) {
          let e = document.getElementsByName(event.target.name);
          if (this.isDateTime(event)) {
            if (e && e[0]) {
              e[0].style["color"] = success;
            }
          } else {
            if (e && e[0]) e[0].style["color"] = fail;
          }
        }
      }
      return false;
    },
    isDateTime(d) {
      if (d instanceof Date) {
        return !isNaN(d);
      }
      if (typeof d === "string") {
        return this.isDateTime(new Date(d));
      }
      if (d instanceof Event) {
        if (d["target"] && d.target instanceof HTMLInputElement) return this.isDateTime(new Date(d.target.value));
      }
    },
    openAgEditProducts() {
      this.agSelectedProducts = [];
      this.agSelectedProducts = [].concat(this.selectedProducts);
      this.openProductPopup = true;
    },
    openCustomer() {
      document.getElementById("lnkMusteri").click();
    },
    openReturnRequest() {
      this.openReturnRequestPopup = true;
    },
    createInvoice: async function(kdvli) {
      let inv = parseInt(this.currentItem.parasutInvoiceId);
      if (!isNaN(inv)) {
        this.$vs.notify({
          title: "title",
          text: "Daha önce fatura kesilmiş!",
          color: "primary",
        });
        return;
      }

      let r = await repository.postEntity("Sale/CreateInvoice?orderId=" + this.currentItem.saleOrderId + "&kdvli=" + kdvli);
      if (r.isSuccessful) {
        this.$vs.notify({
          color: "success",
          icon: "done",
          title: "Tamam",
          text: "Fatura eklendi!",
        });
        this.$emit("hideDisplayPrompt");
      } else if (r.hasExceptionError) {
        this.$vs.notify({
          color: "danger",
          title: "Hata",
          text: r.exceptionMessage,
        });
      } else {
        this.$vs.notify({
          color: "danger",
          title: "Hata",
          text: "Bilinmeyen bir sebepten işlem tamamlanamadı!",
        });
      }
    },

    createAccountMovement: async function() {
      let resultConfirm2 = await this.$swal.fire({
        icon: "warning",
        title: "Devam etmek istediğinize emin misiniz?",
        //text: "",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Evet",
        cancelButtonText: "Hayır",
      });

      if (resultConfirm2.isConfirmed) null;
      else return;

      this.$vs.loading();
      await repository.postEntity("Sale/createAccountMovement", { orderId: this.currentItem.saleOrderId });

      this.$vs.loading.close();

      await this.$swal.fire({
        icon: "success",
        title: "İşlem Başarılı.",
        text: "Satıcı onayı için muhasebe kayıtları oluşturuldu. Bekleyen muhasebelerden onaylayabilirsiniz.",
        showCancelButton: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Evet",
        cancelButtonText: "Hayır",
      });
    },

    init: async function() {
      await Promise.all([this.getSaleOrderType(), this.getPaymentTypes(), this.getCurrencies(), this.getOrderTypes()]);
      await this.getCurrentItem();
      let disabledValues = [5, 9, 97, 98, 99, 4, 100];
      if (this.currentItem) {
        if (this.currentItem.parasutInvoiceId > 0 || disabledValues.find((x) => x == this.currentItem.saleOrderStatusId)) {
          this.isEditDisabled = true;
        } else {
          this.isEditDisabled = false;
        }
        let fn = this.currentItem.customer;
        let span = fn.indexOf("</span>");
        if (span > 0) {
          this.currentItem.customer_span = true;
        }
      }
    },
    closeReturnRequestPopup(r) {
      console.log("closeReturnRequestPopup", r);
      this.openReturnRequestPopup = false;
    },
    closeProductPopup(r, data) {
      if (r == 1) {
        this.selectedProducts = [];
        this.selectedProducts = [].concat(data);
        this.calculate();
      }
      this.openProductPopup = false;
    },
    deleteRow: function(d) {
      this.selectedProducts = this.selectedProducts.filter((val) => d.productId != val.productId || d.wareHouseId != val.wareHouseId);
      this.calculate();
    },
    //açılısta verıtabanından gelen fiyatları kullanacagımız sekılde uygun bır lısteye donsturen hesaplamalar

    getCurrentItem: async function() {
      let a = await repository
        .postEntity("Sale/getOrders", this.salesModel)
        .then((r) => r.list)
        .then((r) => r[0]);
      a = repository.convertToJSON(a, "products");
      a = repository.convertToJSON(a, "customerPhone");
      this.currentItem = a;

      this.tempCurrency = this.selectedMoneyCurrencyOptions.find((x) => x.value == this.currentItem.currency);
      this.tempPaymentType = this.selectedPaymentTypeOptions.find((x) => x.value == this.currentItem.paymentType);
      this.tempDeliveryType = this.selectedDeliveryTypeOptions.find((x) => x.value == this.currentItem.deliveryType);
      this.tempOrderType = this.selectedOrderTypesOptions.find((x) => x.value == this.currentItem.saleOrderType);

      this.beautifyPhone = this.currentItem.customerPhone;

      this.currentItem.validUntil = this.currentItem.validUntil.substr(0, 16);
      this.currentItem.manualCreatedDate = this.currentItem.manualCreatedDate.substr(0, 16);
      if (this.currentItem.invoiced == 0) this.invoiceStatus = "Fatura kesilecek";
      else if (this.currentItem.invoiced > 0) this.invoiceStatus = "Fatura kesildi";
      else this.invoiceStatus = "";

      this.changeProducts();
      this.calculate();

      this.softwareProductList = this.currentItem.products.filter((r) => r.ProductType == "Software");

      return this.currentItem;
    },
    changeProducts() {
      this.selectedProducts = [];
      for (let i = 0; i < this.currentItem.products.length; i++) {
        let e = this.currentItem.products[i];
        let pr = 0;
        if (this.currentItem.taxIncluded && this.currentItem.createdDate<='2023-07-15') {
          pr = e.priceDiscounted * 1.18;
        }
        if (this.currentItem.taxIncluded && this.currentItem.createdDate>'2023-07-15') {
          pr = e.priceDiscounted * 1.20;
        }
        if (!this.currentItem.taxIncluded) {
          pr = e.priceDiscounted;
        }
        this.selectedProducts.push({
          price: e.price || e.priceDiscounted,
          priceWithTaxes: 0,
          productCategory: "Diğer",
          productCategoryID: 4,
          productDescription: null,
          productId: e.productId,
          productName: e.productName,
          quantity: e.productAmount,
          sellPrice: pr.toFixed(2),
          stock: 1,
          wareHouse: e.wareHouse,
          wareHouseId: e.wareHouseId,
          isEdit: true,
          id: e.orderLineId,
          isSent: e.isSent,
          isReturned: e.isReturned,
          returnedCount: e.isReturned ? e.returnedCount : 0,
        });
      }
    },

    calculate: function() {
      this.grandTotal.sumUnitPrice = 0;
      this.grandTotal.sumquantity = 0;
      this.grandTotal.priceDiscounted = 0;
      this.grandTotal.discountPercent = 0;
      let sumSalePrice = 0;

      if (this.selectedProducts.length > 0) {
        for (let i = 0; i < this.selectedProducts.length; i++) {
          //toplam birim fiyat
          this.grandTotal.sumUnitPrice += this.selectedProducts[i].price * this.selectedProducts[i].quantity;
          //toplam adet
          this.grandTotal.sumquantity += parseInt(this.selectedProducts[i].quantity);

          //satıs kalemlerinin toplamı
          sumSalePrice += this.selectedProducts[i].sellPrice * this.selectedProducts[i].quantity;

          //toplam indirmli fiyat
          this.grandTotal.priceDiscounted += parseFloat(this.selectedProducts[i].sellPrice) * parseFloat(this.selectedProducts[i].quantity);

          //toplam indirim yüzdesi
          this.grandTotal.discountPercent = (sumSalePrice - this.grandTotal.sumUnitPrice) / this.grandTotal.sumUnitPrice;
          if (isNaN(this.grandTotal.discountPercent)) this.grandTotal.discountPercent = 0;
        }
      }
    },
    profit: function(e) {
      let a = (e.sellPrice - e.price) / e.price;
      if (a < 0.01 && a > -0.01) return "-";
      a = a * 100;
      return a;
    },
    beautifyProfit: function(e) {
      let r = this.profit(e);
      if (typeof r == "number") {
        return "%" + parseFloat(r).toFixed(2);
      }
      return "-";
    },

    cancel() {
      this.$emit("hideDisplayPrompt");
    },
    close() {
      this.$emit("hideDisplayPrompt");
    },
    isAdmin() {
      return false;
      // eslint-disable-next-line
      return this.$store.state.userData.role === "Admin";
    },
    validate() {
      return this.tempDeliveryType && this.tempDeliveryType.id >= 0 && this.tempCurrency && this.tempCurrency.id >= 0 && this.tempPaymentType;
    },
    accept: async function() {
      ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      //Bu kısım pair ürünler için belirli bir sayıda satılması için kodlanmıştır.
      if (this.$store.state.userData.authorizationList.find((f) => f.authorizationId == "11") != null) {
        null;
      } else {
        let pairProductList = this.selectedProducts.filter((r) => [1638, 1917, 2937, 1347, 1348, 1349, 1350, 1351, 1352, 1354, 1355, 1357, 3156, 3006].includes(r.productId));

        let sumOfQuantity = pairProductList.reduce((acc, ele) => {
          return acc + ele.quantity;
        }, 0);

        if (sumOfQuantity > 0 && sumOfQuantity < 3) {
          await this.$swal.fire({
            icon: "warning",
            title: "Ürün Grubunda Yetersiz Sayı Hatası",
            text: "ProductId si [1638, 1917, 2937, 1347, 1348, 1349, 1350, 1351, 1352, 1354, 1355, 1357, 3156, 3006] olan ürünler için en az toplam 3 adet olmalıdır.",
            showCancelButton: false,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Tamam",
            cancelButtonText: "Hayır",
          });
          return;
        }
      }
      //Bu kısım pair ürünler için belirli bir sayıda satılması için kodlanmıştır.
      ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

      if (this.isEditDisabled) {
        return;
      }
      let control = false;
      control = this.validateForm && this.validate() && this.$validator.validateAll();
      function getDate(x) {
        let d = x.split(" ");
        d[0] = d[0]
          .split(".")
          .reverse()
          .join("-");
        return d.join(" ");
      }
      for (let i = 0; i < this.selectedProducts.length; i++) {
        //id boşsa id alanı oluştur
        if (!this.selectedProducts[i].id) this.selectedProducts[i].id = -1;
        //wareHouseId alanı boşsa oluştur
        if (!this.selectedProducts[i].wareHouseId) this.selectedProducts[i].wareHouseId = -1;

        //price alanı boşsa sellPrice dan al
        if (!this.selectedProducts[i].price || this.selectedProducts[i].price <= 0) this.selectedProducts[i].price = this.selectedProducts[i].sellPrice;

        let price = parseFloat(this.selectedProducts[i].sellPrice);
        if (isNaN(price)) return;

        //measure price without discounted
        if (this.currentItem.taxIncluded && this.currentItem.createdDate<='2023-07-15') price = price * 0.8474576271186440677966101694915254237288135593220338983050847457;
        if (this.currentItem.taxIncluded && this.currentItem.createdDate>'2023-07-15') price = price *  0.8333333333333333333333333333333333333333333333333333333333333333;
        this.selectedProducts[i].priceDiscounted = price;

        //productamount=quantity
        this.selectedProducts[i].productAmount = this.selectedProducts[i].quantity;
        this.selectedProducts[i].priceId=3;
      }
      let postModel = {
        saleOrderId: this.currentItem.saleOrderId,
        customerId: this.currentItem.customerId,
        isFullInvoice: this.currentItem.isFullInvoice,
        orderNote: this.currentItem.saleOrderNote,
        saleOrderType: this.tempOrderType && this.tempOrderType.id >= 0 ? this.tempOrderType.id : this.tempOrderType,
        createdDate: getDate(this.currentItem.manualCreatedDate),
        validUntil: getDate(this.currentItem.validUntil),
        taxIncluded: this.currentItem.taxIncluded,
        currencyType: this.tempCurrency.id,
        paymentType: this.tempPaymentType && this.tempPaymentType.id >= 0 ? this.tempPaymentType.id : this.tempPaymentType,
        deliveryType: this.tempDeliveryType.id,
        deliveryAddress: this.currentItem.deliveryAddress,
        OrderLines: this.selectedProducts,
        price: this.grandTotal.sumUnitPrice,
        priceDiscounted: this.grandTotal.priceDiscounted,
        discount: this.grandTotal.priceDiscounted,
        discountPercent: this.grandTotal.discountPercent,
        lineType: 1,
       
      };

      if (!this.validate()) {
        this.$vs.notify({
          title: "Hata",
          text: "Eksik bilgi var",
          color: "primary",
        });
        return;
      }

      ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      //Bu kısım Sale Rule içindir.
      //#region SaleRule

      if (this.$store.state.userData.authorizationList.find((f) => f.authorizationId == "19") != null) {
        null;
      } else {
        let fullInvoiceProductList = postModel.OrderLines.filter((r) =>
          [2334, 2789, 1941, 1933, 2738, 2739, 2746, 2743, 2744, 2740, 2849, 2847, 2741, 2742, 2854, 2853, 2965, 2966, 1078, 1507, 2885, 2960, 2893, 2018, 2107, 2843, 3157, 3158, 3159, 3160, 3161].includes(r.productId)
        );

        let sumOfFullInvoiceQuantity = fullInvoiceProductList.reduce((acc, ele) => {
          return acc + ele.quantity;
        }, 0);


        //Kural 1
        if (postModel.paymentType == 7 && (postModel.currencyType != 3 || postModel.isFullInvoice == false)) {
          await this.$swal.fire({
            icon: "warning",
            title: "Ödeme türü  TL ve Tam Fatura olmalıdır",
            text: "Ödeme türü kurumsal olan işlemler için para türü TL ve Tam Fatura olmalıdır",
            showCancelButton: false,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Tamam",
            cancelButtonText: "Hayır",
          });
          return;
        }

        //Kural 2
        if (sumOfFullInvoiceQuantity > 0 && postModel.isFullInvoice == false) {
          await this.$swal.fire({
            icon: "warning",
            title: "Ürün Grubu Tam Fatura Hatası",
            text: `ProductId si  2334, 2789, 1941, 1933, 2738, 2739, 2746, 2743, 2744, 2740, 2849, 2847, 2741, 2742, 2854, 2853, 2965, 2966, 1078,
                    1507, 2885, 2960, 2893, 2018, 2107, 2843, 3157, 3158, 3159, 3160, 3161 olan ürünler için tam fatura seçili olmalıdır.`,
            showCancelButton: false,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Tamam",
            cancelButtonText: "Hayır",
          });
          return;
        }

        //Kural 3
        if (postModel.paymentType == 4 && postModel.currencyType == 3) {
          await this.$swal.fire({
            icon: "warning",
            title: "Hata",
            text: "Ödeme türü açık hesap olan işlemler için para türü $ veya € olmalıdır",
            showCancelButton: false,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Tamam",
            cancelButtonText: "Hayır",
          });
          return;
        }
      }
      //#endregion
      //Bu kısım Sale Rule içindir.
      ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

      if (control) {
        let r = await repository.postEntity("Sale/EditOrder", postModel);
        if (r.isSuccessful) {
          this.$vs.notify({
            color: "success",
            icon: "done",
            title: "Tamamlandı",
            text: "Başarıyla düzenlendi!",
          });
          this.$emit("hideDisplayPrompt");
        } else if (r.hasExceptionError) {
          this.$vs.notify({
            color: "danger",
            title: "Hata",
            text: r.exceptionMessage,
          });
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Hata",
            text: "Bilinmeyen bir sebepten işlem tamamlanamadı!",
          });
        }
      } else {
        this.$vs.notify({
          color: "danger",
          title: "Hata",
          text: "Eksik alanlar var!",
        });
      }
    },

    getPaymentTypes: async function() {
      let a = await repository.getAll("Accounting/getPaymentTypes");
      if (a && a.list) this.selectedPaymentTypeOptions = a.list;
      else {
        this.$vs.notify({
          title: "Ödeme Tipleri Çekilemedi",
          text: (a && a.hasExceptionError && a.exceptionMessage) || "bilinmeyen hata oluştu.",
          color: "danger",
          icon: "warning",
        });
      }
    },
    getCurrencies: async function() {
      let a = await repository.getAll("General/getCurrencies");
      if (a && a.list) this.selectedMoneyCurrencyOptions = a.list;
      else {
        this.$vs.notify({
          title: "Para Birimleri Çekilemedi",
          text: (a && a.hasExceptionError && a.exceptionMessage) || "bilinmeyen hata oluştu.",
          color: "danger",
          icon: "warning",
        });
      }
    },
    getOrderTypes: async function() {
      let a = await repository.getAll("Sale/getOrderTypes");
      if (a && a.list) this.selectedOrderTypesOptions = a.list;
      else {
        this.$vs.notify({
          title: "Teslimat Türleri Çekilemedi",
          text: (a && a.hasExceptionError && a.exceptionMessage) || "bilinmeyen hata oluştu.",
          color: "danger",
          icon: "warning",
        });
      }
    },
    getSaleOrderType: async function() {
      let a = await repository.getAll("General/getDeliveryTypes");
      if (a && a.list) this.selectedDeliveryTypeOptions = a.list;
      else {
        this.$vs.notify({
          title: "Satış Tipleri Çekilemedi",
          text: (a && a.hasExceptionError && a.exceptionMessage) || "bilinmeyen hata oluştu.",
          color: "danger",
          icon: "warning",
        });
      }
    },
    changeTax: async function() {
      console.log("changeTax", this.convertTaxValue);
      if (!(this.currentItem.technicId > 0)) {
        this.$vs.notify({
          title: "Kdv Hatası",
          text: "Sadece teknik ve garaj satışları üzerinde işlem yapılabilir.",
          color: "danger",
        });
        return;
      }
      if (!(parseInt(this.convertTaxValue) > 0 && parseInt(this.convertTaxValue) < 5)) {
        this.$vs.notify({
          title: "Kdv Hatası",
          text: "Lütfen seçim yapınız",
          color: "warning",
        });
        return;
      }
      let r = await repository.postEntity("Sale/ConvertTax", {
        id: this.currentItem.technicId,
        value: this.convertTaxValue,
      });
      if (r && r.isSuccessful) {
        this.$vs.notify({
          title: "Kdv: Başarılı",
          text: "Kdv dönüştürme işlemi başarılı",
          color: "success",
        });
        this.close();
      } else {
        this.$vs.notify({
          title: "Kdv Hatası",
          text: r.exceptionMessage || "Bilinmeyen hata",
          color: "danger",
        });
      }
    },
    importToLogo: async function() {
      let r = await repository.postEntity("Sale/ImportToLogo/" + this.currentItem.saleOrderId);
      if (r && r.success) {
        this.$vs.notify({
          title: "İrsaliye oluşturuldu",
          text: "Başarılı",
          color: "success",
        });
      } else {
        this.$vs.notify({
          title: "İrsaliye logoya aktarılamadı",
          text: (r && r.hasExceptionError && r.exceptionMessage) || "bilinmeyen hata oluştu.",
          color: "danger",
          icon: "warning",
        });
      }
    },
    SaveActivationForm: async function() {
      console.log(this.currentItem);
      this.popupActivationForm = true; //Bu event popupı otomatik olarak kapatıyordu. Bu yüzden kapanmasını engelledik.
      let resultConfirm = await this.$swal.fire({
        icon: "warning",
        title: "Devam etmek istediğinize emin misiniz?",
        text: "Onayınız ile birlikte aktivasyon e-maili atılıp satın alma kaydı oluşturulacaktır.",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Evet",
        cancelButtonText: "Hayır",
      });

      if (resultConfirm.isConfirmed) {
        this.$vs.loading();

        await repository.postEntity("Sale/SaveLicenceActivation", this.currentItem);

        this.$vs.loading.close();

        await this.$swal.fire({
          icon: "success",
          title: "İşlem Başarılı. ",
          text: "Aktivasyon Form E-Maili  gönderildi ve Satın Alma Modül'ünde satın alma kaydı oluşturuldu.",
          showCancelButton: false,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Tamam",
          cancelButtonText: "Hayır",
        });
        this.popupActivationForm = false;
      }
    },
  },
  created() {
    this.init();
  },

  computed: {
    beautifyDiscount() {
      if (this.grandTotal.discountPercent < 0.01 && this.grandTotal.discountPercent > -0.01) {
        if (this.grandTotal.discountPercent < 0.000000001 && this.grandTotal.discountPercent > -0.000000001) return "-";
        else return "- / " + (this.grandTotal.priceDiscounted - this.grandTotal.sumUnitPrice).toFixed(2) + " " + ((this.tempCurrency && this.tempCurrency.logo) || "₺");
      }
      return "% " + (this.grandTotal.discountPercent * 100).toFixed(2) + " / " + (this.grandTotal.priceDiscounted - this.grandTotal.sumUnitPrice).toFixed(2) + " " + ((this.tempCurrency && this.tempCurrency.logo) || "₺");
    },
    activePrompt: {
      get() {
        return this.displayPrompt;
      },
      set() {},
    },
    validateForm() {
      return !this.errors.any();
      /*&&(
        new Date(this.currentItem.manualCreatedDate) <
          new Date(this.currentItem.validUntil) &&
        !isNaN(parseInt(this.currentItem.tempDeliveryType)) &&
        !isNaN(parseInt(this.currentItem.tempPaymentType)) &&
        !isNaN(parseInt(this.currentItem.tempOrderType)) &&
        Array.isArray(this.currentItem.selectedProducts) && this.currentItem.selectedProducts.length>0));*/
    },
  },
};
</script>

<style lang="scss" scoped>
#saleEdit {
  .trWithPadding td {
    padding: 4px 10px !important;
  }
  .scroll-area {
    position: relative;
    margin: auto;
    height: 70vh;
  }
}
</style>
